import { useEffect, useState } from 'react'
import { API_URL, getClassNameForField, projectFields as fields } from '../../constants'
import { EditableFormPage } from '../components/EditableFormPage'
import { useTranslationService } from '../../util/TranslationContext'

const ProjectsCreate = () => {
    const [options, setOptions] = useState([])
    const { translateFields } = useTranslationService()
    const projectFields = translateFields(fields, 'projects')

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const token = localStorage.getItem('token')
                const response = await fetch(`${API_URL}/admin/project-categories`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Accept-Language': 'en',
                    },
                })
                const result = await response.json()

                // Assuming response.data.data is the array of categories
                const mappedOptions = result.data.map(item => ({
                    label: item.title,
                    value: item.id,
                }))
                setOptions(mappedOptions)
            } catch (error) {
                console.error('Error fetching options:', error)
            }
        }

        fetchOptions()
    }, [])

    return (
        <>
            <EditableFormPage
                submitUrl='admin/projects'
                fields={projectFields}
                classNameForField={getClassNameForField}
                errorMessage='Failed to fetch projects data.'
                create={true}
                options={options}
                navigateLink='/admin/auth/projects'
            />
        </>
    )
}

export default ProjectsCreate
